import { useChat } from '@/context/ChatContext';

export function WhatsAppButton() {
  const { message } = useChat();
  const href = 'https://wa.me/971523577644?text=' + encodeURIComponent(message);
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-chat-button"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-[55] w-14 h-14 rounded-full bg-[#25D366] shadow-lg flex items-center justify-center hover:scale-110 transition-transform"
    >
      <svg viewBox="0 0 32 32" width="28" height="28" fill="#fff" aria-hidden="true">
        <path d="M16.001 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.257.59 4.46 1.71 6.402L3.2 28.8l6.57-1.72a12.74 12.74 0 006.23 1.62h.005c7.06 0 12.8-5.74 12.8-12.8 0-3.42-1.332-6.636-3.751-9.055A12.72 12.72 0 0016.001 3.2zm0 23.36h-.004a10.6 10.6 0 01-5.4-1.48l-.388-.23-4.006 1.05 1.07-3.906-.253-.4a10.56 10.56 0 01-1.62-5.64c0-5.867 4.775-10.64 10.65-10.64a10.58 10.58 0 017.53 3.12 10.56 10.56 0 013.12 7.526c0 5.867-4.775 10.64-10.649 10.64zm5.836-7.968c-.32-.16-1.892-.933-2.185-1.04-.293-.107-.507-.16-.72.16-.213.32-.826 1.04-1.013 1.253-.187.213-.373.24-.693.08-.32-.16-1.35-.498-2.572-1.587-.95-.848-1.592-1.895-1.779-2.215-.187-.32-.02-.493.14-.652.144-.143.32-.373.48-.56.16-.187.213-.32.32-.533.107-.213.053-.4-.027-.56-.08-.16-.72-1.735-.986-2.375-.26-.624-.524-.54-.72-.55l-.613-.011c-.213 0-.56.08-.853.4-.293.32-1.12 1.094-1.12 2.669 0 1.574 1.147 3.095 1.307 3.308.16.213 2.256 3.445 5.467 4.83.764.33 1.36.527 1.824.674.767.244 1.464.21 2.016.127.615-.092 1.892-.773 2.159-1.52.267-.746.267-1.386.187-1.52-.08-.133-.293-.213-.613-.373z"/>
      </svg>
    </a>
  );
}
